module.exports = __webpack_public_path__ + "static/media/flask-4.403a77b0.svg";